import { render, staticRenderFns } from "./ProfessorGeneroCard.vue?vue&type=template&id=0be87997&scoped=true"
import script from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
export * from "./ProfessorGeneroCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorGeneroCard.vue?vue&type=style&index=0&id=0be87997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be87997",
  null
  
)

export default component.exports